import store from '..'
import * as types from '../mutation-types'

const EXPENSE_DETAIL_TYPE = 3

export default {
	namespaced: true,
	state: {
		expenses: [],
		stockId: null,
		isPosted: false
	},

	actions: {
		fetchExpenses({ commit }, { date }) {
			return window.axios.get('/employeeStock/details/search', {
				params: {
					employeeIds: [store.state.auth.self.employeeId],
					fromDate: date,
					toDate: date,
					custodyDetailTypes: [EXPENSE_DETAIL_TYPE]
				},
				// the endpoint expects repeated keys (collectionFormat: multi); axios' default
				// `ids[]=` form is not bound by the API and the filter is silently ignored
				paramsSerializer: { indexes: null }
			}).then(({ data }) => {
				const expenses = data.details || []
				// each detail carries its parent stock row (id + isPosted) - when the day
				// has no expenses yet there's nothing to read that from, so the current
				// stock row is fetched once on its own instead
				const stockInfo = expenses.length
					? Promise.resolve(expenses[0].stock)
					: window.axios.get('/employeeStock/mine').then(({ data }) => data)

				return stockInfo.then(stock => {
					commit(types.STORE_EMPLOYEE_STOCK_EXPENSES, {
						expenses,
						stockId: stock ? stock.id : null,
						isPosted: Boolean(stock && stock.isPosted)
					})
				})
			})
		},

		addExpense({ dispatch, state }, { date, name, amount }) {
			return window.axios.post(`/employeeStock/${state.stockId}/details`, {
				name,
				amount,
				custodyDetailsType: EXPENSE_DETAIL_TYPE
			}).then(() => dispatch('fetchExpenses', { date }))
		},

		updateExpense({ dispatch }, { date, id, name, amount }) {
			return window.axios.put(`/employeeStock/details/${id}`, {
				name,
				amount,
				custodyDetailsType: EXPENSE_DETAIL_TYPE
			}).then(() => dispatch('fetchExpenses', { date }))
		},

		deleteExpense({ dispatch }, { date, id }) {
			return window.axios.delete(`/employeeStock/details/${id}`)
				.then(() => dispatch('fetchExpenses', { date }))
		},

		reset({ commit }) {
			commit(types.RESET_EMPLOYEE_STOCK)
		}
	},

	mutations: {
		[types.STORE_EMPLOYEE_STOCK_EXPENSES](state, { expenses, stockId, isPosted }) {
			state.expenses = expenses
			state.stockId = stockId
			state.isPosted = isPosted
		},

		[types.RESET_EMPLOYEE_STOCK](state) {
			state.expenses = []
			state.stockId = null
			state.isPosted = false
		}
	},

	getters: {
		getExpenseEntries: state => state.expenses
	}
}
